var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "section",
    { class: [_vm.namespace(), _vm.skinStyle] },
    [
      _vm.isCollapsed
        ? _c("markets-ui-menu-button", {
            attrs: { label: _vm.menuLabel, skin: _vm.skin, size: _vm.size },
            on: { click: _vm.dropdownButtonClicked }
          })
        : _c(
            "div",
            { class: _vm.mdsNS("button-group") },
            _vm._l(_vm.menusData, function(item) {
              return _c(
                "button",
                {
                  key: item.id,
                  class: _vm.btnClasses(item),
                  attrs: { type: "button", value: item.id },
                  on: {
                    click: function($event) {
                      return _vm.click(item)
                    }
                  }
                },
                [_vm._v("\n            " + _vm._s(item.name) + "\n        ")]
              )
            }),
            0
          ),
      _vm._v(" "),
      _c(
        "markets-ui-popover",
        {
          attrs: {
            target: _vm.popoverTarget,
            visible: _vm.popoverVisible,
            skin: _vm.skin
          },
          on: { hide: _vm.hidePopover }
        },
        [
          _c("markets-ui-list", {
            attrs: { dataModel: _vm.menusData, size: _vm.size, skin: _vm.skin },
            on: { change: _vm.change }
          })
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }